import { Stack, Typography } from "@mui/material";
import useRotatingSpinnerVerb from "../hooks/useRotatingSpinnerVerb";
import AnimatedButterfly from "./AnimatedButterfly";

export default function SpinnerVerbsIndicator() {
  const verb = useRotatingSpinnerVerb(true);

  return (
    <Stack spacing={2.5} sx={{ alignItems: "center", px: 2, zIndex: 1 }}>
      <AnimatedButterfly />
      <Typography
        sx={{
          color: "text.primary",
          fontSize: "1.75rem",
          fontWeight: 600,
          lineHeight: 1.2,
          minHeight: "2.1rem",
          textAlign: "center",
        }}
      >
        {verb}…
      </Typography>
    </Stack>
  );
}
